import { callApi } from "./Api";

export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const GET_DEPARTMENT = 'GET_DEPARTMENT';
export const GETINVITATIONBYCODE = 'GETINVITATIONBYCODE';
export const REGISTER = 'REGISTER';
export const UPLOAD = 'UPLOAD';


export const createAccount = (obj) => (dispatch, getState) => {
  let url = `invitations/with/{invitationCode}`;

  callApi(dispatch, getState, CREATE_ACCOUNT, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  });
}

export const getDepartment = () => (dispatch, getState) => {
  let url = `commons/department-options/internal`;

  callApi(dispatch, getState, GET_DEPARTMENT, url);
}

export const getInvitationByCode = (code) => (dispatch, getState) => {
  let url = `invitations/with/${code}`;

  callApi(dispatch, getState, GETINVITATIONBYCODE, url);
}

export const register = (code, obj) => (dispatch, getState) => {
  let url = `invitations/with/${code}/internal-register`;

  callApi(dispatch, getState, REGISTER, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}

export const upload = (formData, code) => (dispatch, getState) => {
  let url = `invitations/with/${code}/logo/upload`;

  callApi(dispatch, getState, UPLOAD, url, {
    method: 'POST',
    headers: {
      'Content-Type': undefined
    },
    body: formData
  });
}


// WEBPACK FOOTER //
// ./src/actions/CreateAccount.js